// extracted by mini-css-extract-plugin
export default {"modal":"ModalInvoke__modal___dw5o8","multiline":"ModalInvoke__multiline___A7aaV","overwrite":"ModalInvoke__overwrite___iqy6_"};